<template>
  <el-table :data="tableData" border style="width: 100%">
    <el-table-column prop="date" label="问题" width="180">
      <template slot-scope="scope">
        <span style="margin-left: 10px">{{ scope.row.subject }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="name" label="类型" width="180">
      <template slot-scope="scope">
        <span style="margin-left: 10px" v-if="scope.row.type==1">选择题</span>
        <span style="margin-left: 10px" v-if="scope.row.type==2">填空题</span>
        <span style="margin-left: 10px" v-if="scope.row.type==3">判断题</span>
        <span style="margin-left: 10px" v-if="scope.row.type==4">简答题题</span>
      </template>
    </el-table-column>
    <el-table-column prop="address" label="选项A">
      <template slot-scope="scope">
        <span style="margin-left: 10px">{{ scope.row.a }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="address" label="选项B">
      <template slot-scope="scope">
        <span style="margin-left: 10px">{{ scope.row.b }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="address" label="选项C">
      <template slot-scope="scope">
        <span style="margin-left: 10px">{{ scope.row.c }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="address" label="选项D">
      <template slot-scope="scope">
        <span style="margin-left: 10px">{{ scope.row.d }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="address" label="正确答案">
      <template slot-scope="scope">
        <span style="margin-left: 10px">{{ scope.row.right }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="address" label="员工答案">
      <template slot-scope="scope">
        <span style="margin-left: 10px">{{ scope.row.answer }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import axios from 'axios';
export default {
  name: 'login',
  data () {
    return {
      tableData:[]
    }
  },
  created(){
    console.log(this.$route.params.id);
    console.log(this.$route.params.memberId);
    this.getdata()
  },
  methods:{
    getdata:function(){
      axios.get('/admin/examine/answer', {
        params: {
          sec: localStorage.token,
          id:this.$route.params.id,
          memberId:this.$route.params.memberId
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
          this.tableData = response.data.data;
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/examfinish.vue